module.exports = __webpack_public_path__ + "static/media/wave-box-top.37bfc9d5.svg";